import { getNavigationBarHeight } from './navigation';
import { triggerPageView } from '../analytics/analytics';
import { toggleError, validateField } from './form';
import { getHashProperty } from './_utils';

const classNames = {
	formHidden: 'ContactForm-form--hidden',
	errorHidden: 'ContactForm-error--hidden',
	successHidden: 'ContactForm-success--hidden',
	filledField: 'formElement-field--filled',
	dropdownFieldChanged: 'Dropdown-field--changed',
};

// TODO: Change these to template literals to reduce text
const selectors = {
	baseContainer: '.ContactForm',
	contactForm: '.ContactForm-form',
	phoneCheckbox: '.ContactForm-PrimaryPhone .Checkbox-input',
	phoneInput: '.ContactForm-Phone .TextInput-field',
	successPage: '.ContactForm-success',
	successPageCta: '.ContactForm-cta',
	errorMsg: '.ContactForm-error',
	field: '.formElement-field',
	typeaheadFields: '.TypeAhead-textField .TextInput-field',
	dropdownField: 'Dropdown-field',
	reasonForContact: '#reasonForContact',
};

// TODO: Refactor this file to work with more than one contact form
// TODO: Fix variable names to specify which are jQuery objects
export default function contactFormSubmission() {
	const baseContainer = $(selectors.baseContainer);
	if (baseContainer.length > 0) {
		const contactForm = $(selectors.contactForm);
		const successPage = $(selectors.successPage);
		const successPageCta = $(selectors.successPageCta);
		const errorMsg = $(selectors.errorMsg);
		const submitErrorText = errorMsg.data('text');
		const phoneInput = $(selectors.phoneInput);
		const phoneCheckbox = $(selectors.phoneCheckbox);
		const dropdownFields = baseContainer.find(selectors.dropdownField);
		const reasons = baseContainer.find(selectors.reasonForContact);

		//check if there's a hash value that matches a reason for contact, and preselect it if there is
		const hashValue = getHashProperty();
		if (hashValue && reasons.find(`option[value="${hashValue}"]`).length) {
			// set the value and trigger a validation so the label and error messages get updated
			reasons.val(hashValue);
			validateField(reasons);
		}

		// Deactivate and uncheck primary phone checkbox when there is no phone
		phoneInput.on('input', e => {
			phoneCheckbox.prop('disabled', $(e.target).val().length === 0);
			phoneCheckbox.prop('disabled') && phoneCheckbox.prop('checked', false);
		});

		//Submit form
		function submitForm() {
			const data = contactForm.serializeArray();
			const navigationBarHeight = getNavigationBarHeight();

			/* Get real value from typeahead fields
				Get the item in data that holds the value for the typeahead field.
				Then change that value with the real value from the node's data attribute */
			const typeaheadFields = contactForm.find(selectors.typeaheadFields);
			if (typeaheadFields.length > 0) {
				typeaheadFields.each((_, field) => {
					const $field = $(field);
					const fieldName = $field.attr('name');
					const typeaheadDataItem = data.find(dataItem => dataItem.name === fieldName);
					if (typeaheadDataItem) {
						typeaheadDataItem.value = $field.data('value');
					}
				});
			}

			const serializedData = $.param(data);

			const endpoint = contactForm.data('endpoint') || '/alt/apps/fshr/design3/contact.json';

			const errorHandler = () => {
				contactForm.trigger('contactForm.error');
				errorMsg.text(submitErrorText);
				// As toggleError is async, we scroll to the error when it's been placed on the DOM
				toggleError(errorMsg, 'on', 500, {
					start: () =>
						$('html, body').animate(
							{
								scrollTop: errorMsg.offset().top - navigationBarHeight,
							},
							500
						),
				});
			};
			const errorOnNonSuccess = contactForm.data('error-on-non-success') || false;

			$.post(endpoint, serializedData)
				.done(result => {
					if (result.status === 'ok' || result === true) {
						contactForm.addClass(classNames.formHidden);
						successPage.removeClass(classNames.successHidden);
						toggleError(errorMsg, 'off', 0);
						$('html, body').animate(
							{
								scrollTop:
									baseContainer.offset().top -
									parseInt(baseContainer.css('margin-top')) -
									navigationBarHeight,
							},
							500
						);

						let trackingPayload = { event_name: 'form_submit' };
						if (contactForm.data('tracking-form-name')) {
							trackingPayload['form_name'] = contactForm.data('tracking-form-name');
						}
						triggerPageView(trackingPayload);
						contactForm.trigger('contactForm.success');
					} else if (errorOnNonSuccess) {
						errorHandler();
					}
				})
				.fail(errorHandler);
		}
		if (window.FS && window.FS.recaptcha) {
			if (contactForm.data('contactFormSubmit') !== false) {
				var verifyRecaptcha = window.FS.recaptcha.addRecaptcha(contactForm[0]);
				contactForm.on('submit', e => {
					e.preventDefault();
					if (!contactForm.is(':invalid')) {
						verifyRecaptcha(submitForm);
					}
				});
			}
			successPageCta.on('click', e => {
				e.preventDefault();
				const navigationBarHeight = getNavigationBarHeight();

				contactForm[0].reset();
				window.FS.recaptcha.reset(contactForm[0]);
				contactForm
					.find(selectors.field)
					.removeClass(classNames.filledField)
					.each((i, field) => {
						const $field = $(field);
						field.setCustomValidity($field.data('errorMessage'));
					});
				dropdownFields.removeClass(classNames.dropdownFieldChanged);
				contactForm.removeClass(classNames.formHidden);
				successPage.addClass(classNames.successHidden);

				$('html, body').animate(
					{
						scrollTop:
							baseContainer.offset().top -
							parseInt(baseContainer.css('margin-top')) -
							navigationBarHeight,
					},
					500
				);
			});
		}
	}
}
